<section class="content">
    <div class="container-fluid">
        <div class="block-header">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <ul class="breadcrumb breadcrumb-style ">
                        <li class="breadcrumb-item">
                            <h4 class="page-title">Basic Form</h4>
                        </li>
                        <li class="breadcrumb-item bcrumb-1">
                            <a routerLink="/dashboard/main">
                                <i class="fas fa-home"></i> Home</a>
                        </li>
                        <li class="breadcrumb-item bcrumb-2">
                            <a href="#" onClick="return false;">Forms</a>
                        </li>
                        <li class="breadcrumb-item active">Basic</li>
                    </ul>
                </div>
            </div>
        </div>
        <app-maser-page-header></app-maser-page-header>
        <div *ngIf="product_session_available_dict != null" style="margin-top: 15px;">
            <div class="row">
                <div class="col-3"></div>
                <div class="col-2 text-center" *ngFor="let session of sessions">
                    {{ session['name'] }}
                </div>
            </div>
            <div class="row" *ngFor="let product of products" style="padding: 15px;">
                <div class="col-3">
                    {{ product['short_name'] }}
                </div>
                <div class="col-2 text-center" *ngFor="let session of sessions">
                    <button class="label bg-red shadow-style" mat-flat-button color="warn"
                        *ngIf="!product_session_available_dict[session['id']][product['id']]"
                        (click)="onChange(true, session['id'], product['id'])">Not Available</button>
                    <button class="label bg-green shadow-style"  mat-flat-button color="primary"
                        *ngIf="product_session_available_dict[session['id']][product['id']]"
                        (click)="onChange(false, session['id'], product['id'])">Available</button>
                    <!-- <mat-checkbox class="example-margin"
                        [(ngModel)]="product_session_available_dict[session['id']][product['id']]"
                        (ngModelChange)="onChange($event, session['id'], product['id'])"></mat-checkbox> -->
                </div>
            </div>
        </div>
    </div>
</section>